import { api } from './api-client';
import { toQueryString } from './query';
import { ApiResponse, PaginatedResponse, PaginationQuery, Product } from '../types/api';

export interface ProductInput {
  sku: string;
  barcode?: string;
  name: string;
  description?: string;
  categoryId?: number;
  unitMeasureId: number;
  salePrice: string;
  minimumStock: string;
}
export interface ProductQuery extends PaginationQuery {
  categoryId?: number;
  unitMeasureId?: number;
  status?: 'ACTIVE' | 'INACTIVE';
  lowStock?: boolean;
}

export async function listProducts(query: ProductQuery = {}) {
  const response = await api.get<PaginatedResponse<Product>>(`/products${toQueryString(query)}`);
  return response.data;
}
export async function createProduct(input: ProductInput) {
  const response = await api.post<ApiResponse<Product>>('/products', input);
  return response.data.data;
}
export async function getProduct(id: number) {
  const response = await api.get<ApiResponse<Product>>(`/products/${id}`);
  return response.data.data;
}
export async function updateProduct(id: number, input: Partial<ProductInput>) {
  const response = await api.patch<ApiResponse<Product>>(`/products/${id}`, input);
  return response.data.data;
}
export async function updateProductStatus(id: number, status: Product['status']) {
  const response = await api.patch<ApiResponse<Product>>(`/products/${id}/status`, { status });
  return response.data.data;
}
